<template>
    <div>
        <small class="text-muted float-right">{{$t('sandoz.contract_pdf_upload_hint')}}</small><br>
        <dropzone id="dropZoneOrtic" ref="pch"
                  :options="options"
                  :destroyDropzone="false"
                  :duplicateCheck="false"
                  @vdropzone-success="vsuccess"
                  @vdropzone-error="verror"
                  @vdropzone-removed-file="vremoved">
        </dropzone>
    </div>
</template>

<style scoped>
    .dz-image img {
        max-width: 100% !important;
    }
</style>

<script>
  import axios from 'axios'
  import Dropzone from 'nuxt-dropzone'
  import 'nuxt-dropzone/dropzone.css'

  export default {
    name: 'o-pdf-upload-drop',
    components: {
      Dropzone
    },
    props: {
      documents: {
        type: Object
      },
    },
    data() {
      return {
        options: {
          url: "/api/sandoz/contract_pdfs/pdf",
          uploadProgress: true,
          progress: true,
          paramName: "file",
          addRemoveLinks: true,
          maxFiles: 20,
          dictDefaultMessage: this.$i18n.t('sandoz.drop_files'),
          acceptedFiles: "application/pdf"
        }
      }
    },
    methods: {
      vremoved(file, xhr, error) {
        let name = file.name
        let param = {'file': name, 'servername': file.servername}
        if(name !== null) {
          axios.post('/api/sandoz/contract_pdfs/pdf_delete', param).then((response) => {
            this.$emit('document', {file: name, type: 'delete', contract: response.data.contract})
          }).catch((error) => {
            this.$emit('document', {file: name, type: 'delete', contract: response.data.contract})
          })
        }
      },
      vsuccess(file, response) {
        file.servername = response.pdf ? response.pdf.file_name : null
        this.$emit('document', {'file': file.name, type: 'upload', contract: response.contract, status: response.status})
      },
      verror(file) {
        this.$emit('document', {'file': file.name, type: 'upload'})
      }
    }
  }
</script>
